import { createContext, ReactNode, useState, useEffect } from "react";

export type SuperAdminAuthContextValue = {
  isAuthenticated: boolean;
  isLoading: boolean;
  logIn: (token: string) => void;
  logOut: () => void;
  token?: string;
};

export const SuperAdminAuthContext = createContext<SuperAdminAuthContextValue>({
  isAuthenticated: false,
  isLoading: false,
  logIn: () => {},
  logOut: () => {},
});

const SUPER_ADMIN_TOKEN_KEY = "SUPER_ADMIN_TOKEN";

export const SuperAdminAuthProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [token, setToken] = useState<string | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const storedToken = localStorage.getItem(SUPER_ADMIN_TOKEN_KEY);
    if (storedToken) {
      setToken(storedToken);
    }
    setIsLoading(false);
  }, []);

  const logIn = (newToken: string) => {
    localStorage.setItem(SUPER_ADMIN_TOKEN_KEY, newToken);
    setToken(newToken);
  };

  const logOut = () => {
    localStorage.removeItem(SUPER_ADMIN_TOKEN_KEY);
    setToken(undefined);
  };

  return (
    <SuperAdminAuthContext.Provider
      value={{
        isAuthenticated: !!token,
        isLoading,
        logIn,
        logOut,
        token,
      }}
    >
      {children}
    </SuperAdminAuthContext.Provider>
  );
};
